import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import {
  GetZone,
  AddZoneDetails,
  UpdateZoneDetails,
  getZoneById,
} from "../../Apis/organizationApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Loader from "../../Common/Loader/loader";
import { withTranslation, useTranslation } from "react-i18next";
import CustomDataTable from "../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import useCheckPermissions from "./../../Common/Permissions/customHook";
import ExcelJS from "exceljs";
import isGHMC from "../../Common/helper/helpar";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { exportToPDF } from "../../../utils/exportToPDF";

const OrganizationZone = ({ t }) => {
  const navigate = useNavigate();
  const { t: translate, i18n } = useTranslation();
  const [lgShow, setLgShow] = useState(false);
  const isProd = isGHMC();
  // Retrieve a specific permission from localStorage based on an index
  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions,
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(
      `canWrite value for permission ID ${storedPermissions}:`,
      canWriteValue,
    );
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  // const id = data.map((dt)=>dt?.permissionId)
  // const canWriteValue = localStorage.getItem(`permission`);

  // console.log(data)

  const [allzones, setAllZones] = useState([]);
  const [editZoneData, setEditZoneData] = useState(null);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [isZoneLoading, setIsZoneLoading] = useState(true);
  const [filterOriginalZoneData, setFilterOriginalZoneData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [originalZones, setOriginalZones] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formInput, setFormInput] = useState({
    zoneName: "",
    zoneCode: "",
    isActive: true,
  });
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);

  useEffect(() => {
    // Combine sortedData with excelData
    setExcelData(sortedData);
  }, [sortedData]);
  const headers = ["zone", "zoneCode", "status", "actions"];

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...allzones].sort((a, b) => {
      if (sortConfig.order === "asc") {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const fetchData = async () => {
    try {
      setIsZoneLoading(true);
      const data = await GetZone();
      if (data === null) {
        setOriginalZones([]);
      } else {
        setOriginalZones(data);
        setOriginalData(data);
      }
      const sortedCircleData = data.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setOriginalZones(sortedCircleData);
      setIsZoneLoading(false);
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const translatedData = originalZones.map((zone) => ({
      ...zone,
      zone: `${zone.zoneName} [${zone.zoneCode}]`,
      zone:
        zone.zoneName === "జోన్ పేరు" ? "జోన్ పేరు" : translate(zone.zoneName),
      status: zone.isActive ? "Active" : "InActive",
    }));
    setAllZones(translatedData);
    setFilterOriginalZoneData(translatedData);
  }, [originalZones, i18n.language]);

  const handleClose = () => {
    setLgShow(false);
    setFormSubmitted(false);
    setEditZoneData(null);
    setFormInput({
      zoneName: "",
      zoneCode: "",
      isActive: "",
    });
  };

  const handleEditZone = (selectedZone) => {
    setEditZoneData(selectedZone);
    setFormInput({
      zoneName: selectedZone?.zoneName,
      zoneCode: selectedZone?.zoneCode,
      isActive: selectedZone?.isActive,
    });

    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  };

  const handleViewZone = (selectedZone) => {
    setEditZoneData(selectedZone);
    setFormInput({
      zoneName: selectedZone?.zoneName,
      isActive: selectedZone.isActive,
    });
    setLgShow(true);
  };

  const handleCreateZone = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    try {
      setIsOptionsLoading(true);
      if (!formInput.zoneName) {
        if (!formInput.zoneName) {
          document.getElementById("zoneNameError").innerText =
            "Zone is Required";
        }
        // if (!formInput.zoneCode) {
        //   document.getElementById("zoneCodeError").innerText =
        //     "Zone code is Required";
        // }
        return;
      }
      const isDuplicateCode = allzones.some(
        (type) =>
          type.zoneCode === formInput.zoneCode &&
          type.zoneName !== editZoneData?.zoneName &&
          type.zoneId !== editZoneData?.zoneId,
      );
      if (isDuplicateCode) {
        toast.error(
          "Zone Code already exists. Please choose a different one.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          },
        );
        return;
      }
      const isActive = formInput.isActive === "true";
      if (editZoneData) {
        const updatedZoneData = {
          zoneId: editZoneData.zoneId,
          zoneName: formInput.zoneName,
          zoneCode: formInput.zoneCode,
          isActive: formInput.isActive,
        };
        const response = await UpdateZoneDetails(updatedZoneData);
        setOriginalZones([response, ...originalZones]);
        toast.success("Zone updated Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchData();
        handleClose();
      } else {
        const responseData = await AddZoneDetails({
          ...formInput,
        });
        setOriginalZones([responseData, ...originalZones]);
        setIsOptionsLoading(false);
        toast.success("Zone added Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchData();
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 409) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 400) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   const alphabetsOnlyRegex = /^[a-zA-Z\s- 0-9]*$/;
  //   if (value === "" || alphabetsOnlyRegex.test(value)) {
  //     setFormInput({ ...formInput, [name]: value });
  //   }
  // };

  // const handleCodeChange = (e) => {
  //   const { name, value } = e.target;
  //   const alphanumericRegex = /^[a-zA-Z0-9\s]*$/;
  //   if (value === "" || alphanumericRegex.test(value)) {
  //     setFormInput({ ...formInput, [name]: value });
  //   }
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const formattedValue = value
      .slice(0, 42) // Limit to 42 characters
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space

    setFormInput({ ...formInput, [name]: formattedValue });
  };

  const handleCodeChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = value
      .slice(0, 42) // Limit to 42 characters
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
      .replace(/[^A-Za-z0-9\s-]/g, ""); // Allow only letters, numbers, spaces, and hyphens

    setFormInput({ ...formInput, [name]: formattedValue });
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };

  useEffect(() => {
    setFormInput(
      editZoneData || {
        zoneName: "",
        zoneCode: "",
        isActive: "",
      },
    );
  }, [editZoneData]);

  // const handleShow = () => {
  //   if (canAdd) {
  //     setLgShow(true);
  //     setIsOptionsLoading(true);
  //     setTimeout(() => {
  //       setIsOptionsLoading(false);
  //     }, 1000);
  //     setFormInput({
  //       zoneName: "",
  //       zoneCode: "",
  //       isActive: true,
  //     });
  //     setEditZoneData(null);
  //   } else {
  //     toast.error("You do not have permission to add a zone.", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //     });
  //   }
  // };
  const handleShow = () => {
    // if (canAdd) {
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setFormInput({
      zoneName: "",
      zoneCode: "",
      isActive: true,
    });
    setEditZoneData(null);
    // }
  };

  const handleViewZoneData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsOptionsLoading(true);
      const response = await getZoneById(id);
      const zoneDetails = response.data.data[0];
      navigate("/zone-details", { state: { zoneDetails } });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
  }, [allzones]);

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;

  const downloadAsExcel = async () => {
    // Determine if the data is sorted or not
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;

    // Log data for debugging
    console.log("Sorted Data:", sortedData);
    console.log("Original Data:", originalData);
    console.log("Data to Use for Export:", dataToUse);

    if (dataToUse.length === 0) {
      console.error("No data available for export.");
      return; // Exit if there's no data to export
    }

    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone");

    // Define styles
    const boldFont = { bold: true };

    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Zone Report Generated on: ${generationTime}, ${formattedTime}`;

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 4);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add "Zone Details" header
    worksheet.addRow(["", "", "Zone Details", ""]);
    worksheet.mergeCells(2, 2, 2, 4);
    worksheet.getCell(2, 2).value = "Zone Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Define table headers
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Zone Code",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 4) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Background color
          bgColor: { argb: "FFFFFFFF" }, // Text color
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName,
          item.zoneCode,
          item.isActive ? "Active" : "InActive",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.alignment = { horizontal: "left" };
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "ZoneDetails.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  // const DownloadPdf = () => {
  //   // Determine data source
  //   const dataToUse = sortedData.length > 0 ? sortedData : originalData;

  //   console.log("Data to Use for PDF Export:", dataToUse);

  //   if (dataToUse.length === 0) {
  //     console.error("No data available for export.");
  //     return;
  //   }

  //   // Create PDF
  //   const doc = new jsPDF("p", "mm", "a4");

  //   // Page width
  //   const pageWidth = doc.internal.pageSize.getWidth();

  //   // Current date & time
  //   const currentDate = new Date();
  //   const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
  //   const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;

  //   const headerText = `Zone Report Generated on: ${generationTime}, ${formattedTime}`;

  //   // ===== Header =====
  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(11);
  //   doc.text(headerText, pageWidth / 2, 15, { align: "center" });

  //   // ===== Section Title =====
  //   doc.setFontSize(14);
  //   doc.text("Zone Details", pageWidth / 2, 25, { align: "center" });

  //   // ===== Table Data =====
  //   const tableBody = dataToUse.map((item, index) => [
  //     index + 1,
  //     item.zoneName,
  //     item.zoneCode,
  //     item.isActive ? "Active" : "Inactive",
  //   ]);

  //   // ===== Table =====
  //   autoTable(doc, {
  //     startY: 35,
  //     head: [["S.No", "Zone", "Zone Code", "Status"]],
  //     body: tableBody,
  //     theme: "grid",
  //     styles: {
  //       fontSize: 10,
  //       halign: "left",
  //     },
  //     headStyles: {
  //       fillColor: [246, 177, 177], // Same as Excel header color
  //       textColor: [0, 0, 0],
  //       fontStyle: "bold",
  //     },
  //     columnStyles: {
  //       0: { cellWidth: 15 },
  //       1: { cellWidth: 50 },
  //       2: { cellWidth: 45 },
  //       3: { cellWidth: 30 },
  //     },
  //   });

  //   // ===== Download =====
  //   doc.save("ZoneDetails.pdf");
  // };


  

const DownloadPdf = () => {
  const dataToUse = sortedData.length > 0 ? sortedData : originalData;

  const now = new Date();
  const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;

  exportToPDF({
    fileName: "ZoneDetails",
    title: "Zone Details",
    generatedOnText: `Zone Report Generated on: ${generationTime}, ${time}`,
    data: dataToUse,
    landscape :false,
    columns: [
      {
        header: "S.No",
        accessor: (_row, index) => index + 1,
        width: 15,
      },
      {
        header: "Zone",
        accessor: "zoneName",
        width: 50,
      },
      {
        header: "Zone Code",
        accessor: "zoneCode",
        width: 45,
      },
      {
        header: "Status",
        accessor: row => (row.isActive ? "Active" : "Inactive"),
        width: 30,
      },
    ],
  });
};


  const searchZoneHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalZoneData.filter(
      (item) =>
        item?.zoneName?.toLowerCase()?.includes(term) ||
        item?.zoneCode?.toLowerCase()?.includes(term),
    );
    setAllZones(data);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Zone or Zone Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchZoneHandler}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className=" flex_end_middle mb-3">
                    {/* {canAdd && ( */}
                    {/* {canWriteValue === true ? */}
                    <button className="button-container" onClick={handleShow}>
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t("addZone")}
                    </button>
                    {/* : ''} */}
                    {/* )} */}
                    <button
                      className="btn btn-excel"
                      onClick={handleSortAndExport}
                    >
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Excel
                    </button>
                    <button className="btn btn-excel" onClick={DownloadPdf}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Pdf
                    </button>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span>{t("zoneDetails")}</span>
                  </div>
                  {isZoneLoading ? (
                    <Loader />
                  ) : (
                    <TableComponent
                      DataFetchURL={allzones}
                      headers={headers}
                      filterFunction={(data) =>
                        data.filter(
                          (item) => item.status === 1 || item.status === 2,
                        )
                      }
                      // editData={handleEditZone}
                      editData={handleEditZone}
                      editZoneData={editZoneData}
                      viewData={(id) => handleViewZoneData(id)}
                      renderCustomCell={(header, rowData) => {
                        if (header === "జోన్ పేరు") {
                          return rowData.zoneName;
                        } else {
                          return rowData[header];
                        }
                      }}
                      onSort={handleSort}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {isOptionsLoading && <Loader />} */}
      <Modal
        show={lgShow}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editZoneData ? t("editZone") : t("addZone")}
          </Modal.Title>
          <i
            className="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form>
            <div className="row">
              {/* <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Zone Code
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${formInput.zoneCode || !formSubmitted ? "" : "input-error"
                      }`}
                    value={formInput.zoneCode}
                    name="zoneCode"
                    placeholder="Enter Zone Code"
                    onChange={handleCodeChange}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.zoneCode && formSubmitted && (
                    <div className="required-message">
                      Zone Code is Required
                    </div>
                  )}
                </div>
              </div> */}
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {" "}
                    Zone <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="zoneName"
                    className={`form-control ${
                      formInput.zoneName || !formSubmitted ? "" : "input-error"
                    }`}
                    value={formInput.zoneName}
                    placeholder="Enter Zone"
                    onChange={handleInputChange}
                    maxLength={42}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.zoneName && formSubmitted && (
                    <div className="required-message">Zone is Required</div>
                  )}
                </div>
              </div>
            </div>
            {/* {editZoneData && ( */}
            <div className="col-md-4">
              <label className="form-label">
                Status<span style={{ color: "#EC1117" }}> *</span>
              </label>
              <div
                className="form-group"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    value="true"
                    checked={formInput.isActive === true}
                    onChange={handleStatusChange}
                    // disabled={!canWriteValue}
                    color="#EC1117"
                  />
                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "60px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    value="false"
                    checked={formInput.isActive === false}
                    onChange={handleStatusChange}
                    // disabled={!canWriteValue}
                  />
                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            {/* )} */}
            <div className="modal-footer d-flex justify-content-center">
              {/* {canWriteValue ? */}
              <button
                type="submit"
                className="deployment-button"
                onClick={handleCreateZone}
              >
                <i className="fa-solid fa-check done-container"></i>
                {editZoneData ? t("Update") : t("Save")}
              </button>
              {/* : ""} */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(OrganizationZone);
